import { b } from "./chunk-A74TA65P.js";
var d,
  f,
  c = b(() => {
    f = {
      env: d = {
        NODE_ENV: "production",
        npm_package_version: "5.16.0"
      }
    };
  });
export { c as a, f as b };